// API Configuration
// 
// Mode 1: Pages Function (Recommended - same domain, no CORS)
//   - Leave REACT_APP_API_URL empty or unset
//   - API endpoint: /api/data (served by functions/api/data.js)
//
// Mode 2: External Worker
//   - Set REACT_APP_API_URL to your Worker URL: https://coust-api.xxx.workers.dev/
//   - API endpoint: {WORKER_URL}/json/data.php
//
// The app automatically uses the correct endpoint for each mode

const configuredApiPath = process.env.REACT_APP_API_URL || '';
export const API_PATH = configuredApiPath ? `${configuredApiPath.replace(/\/$/, '')}/` : '';
export const CLIENT_PATH = process.env.REACT_APP_CLIENT_URL || '/';

// Full API endpoint for data requests
// Pages Function mode: /api/data?term=XXXX
// Worker mode: https://worker.dev/json/data.php?term=XXXX
export const API_ENDPOINT = API_PATH
    ? `${API_PATH}json/data.php`
    : '/api/data';

export const DEFAULT_TERM = process.env.REACT_APP_DEFAULT_TERM || '2530';

// Debug: Log which mode is active (only in dev)
if (process.env.NODE_ENV === 'development') {
    console.log('API Mode:', API_PATH ? 'External Worker' : 'Pages Function (same-origin)');
    console.log('API Endpoint:', API_ENDPOINT);
}
